import React from 'react';
import { Card } from '../../ui/Card';
import { formatEuro } from '../../../utils/currency';
import { courseTotalCost, externalProductCost, teachingHours, teachingTotal } from '../../../utils/trainingCourses';
import { TrainingCourseDraft } from '../../../types/trainingCourse';
interface CourseCostSummaryProps {
  course: TrainingCourseDraft;
}
interface CostRow {
  label: string;
  value: number;
  detail?: string;
}
export function CourseCostSummary({
  course
}: CourseCostSummaryProps) {
  const teacherCount = (course.teachers || []).filter(t => t.teacherId).length;
  const hours = teachingHours(course);
  const rows: CostRow[] = [{
    label: 'Importo complessivo docenza',
    value: teachingTotal(course),
    detail: `${teacherCount} ${teacherCount === 1 ? 'docente' : 'docenti'} · ${hours.toLocaleString('it-IT')} ore`
  }, {
    label: 'Noleggio attrezzature',
    value: course.equipmentAmount || 0,
    detail: course.equipmentType
  }, {
    label: 'Affitto locali',
    value: course.roomRentalAmount || 0
  }, {
    label: 'Altri costi',
    value: course.otherCostsAmount || 0
  }, ...(course.externalProduct ? [{
    label: 'Costo prodotto esterno',
    value: externalProductCost(course),
    detail: course.externalSupplier
  }] : [])];
  return <Card title="Riepilogo costi" noHoverShadow data-id="element-1100" data-mp="2cv3bpcsyjexp">
      <dl className="space-y-4" data-id="element-1101" data-mp="39hy6pj9r65cy">
        {rows.map(row => <div key={row.label} className="flex items-start justify-between gap-4" data-id="element-1102" data-mp="34k6eeo574h88">
            <dt data-id="element-1103" data-mp="34m94t9a9gcdh">
              <span className="text-sm text-slate-600" data-id="element-1104" data-mp="2zsy6xxnff5xp">{row.label}</span>
              {row.detail && <span className="block text-xs text-slate-400 mt-0.5" data-id="element-1105" data-mp="2vs4gawilnd14">
                  {row.detail}
                </span>}
            </dt>
            <dd className="text-sm font-medium text-slate-800 tabular-nums whitespace-nowrap" data-id="element-1106" data-mp="3sase9s51qv75">
              {formatEuro(row.value)}
            </dd>
          </div>)}
      </dl>
      <div className="mt-5 pt-5 border-t border-slate-100 flex items-baseline justify-between gap-4" data-id="element-1107" data-mp="1llqlpl8fh00b">
        <span className="text-sm font-medium text-slate-600" data-id="element-1108" data-mp="1qjs1nxak4j7k">Totale costi</span>
        <span className="text-2xl font-bold text-seform-navy tabular-nums" data-id="element-1109" data-mp="1bunm6nv5ct35">
          {formatEuro(courseTotalCost(course))}
        </span>
      </div>
    </Card>;
}